// Admin API istemcisi: oturum belirteci tarayıcıda, platform kiracısı `X-Company-Id` başlığıyla gider.
import { ApiClient, ApiError, browserTokenStore } from '@serota/api-client';
import { API_URL } from './config';

export const tokenStore = browserTokenStore('serota.admin.tokens');
const COMPANY_KEY = 'serota.admin.company';

let companyId: string | null = (() => {
  try {
    return localStorage.getItem(COMPANY_KEY);
  } catch {
    return null;
  }
})();

export function getCompanyId(): string | null {
  return companyId;
}

export function setCompanyId(id: string | null): void {
  companyId = id;
  try {
    if (id) localStorage.setItem(COMPANY_KEY, id);
    else localStorage.removeItem(COMPANY_KEY);
  } catch {
    /* depolama yok */
  }
}

type Listener = () => void;
const unauthorized = new Set<Listener>();
export function onUnauthorized(fn: Listener): () => void {
  unauthorized.add(fn);
  return () => unauthorized.delete(fn);
}

export const api = new ApiClient({
  baseUrl: API_URL,
  app: 'admin',
  tokens: tokenStore,
  getCompanyId,
  onUnauthorized: () => unauthorized.forEach((l) => l()),
});

export { ApiError };

/** Kullanıcıya gösterilecek hata metni. */
export function errorText(e: unknown, fallback = 'Bir sorun oluştu. Birazdan tekrar deneyin.'): string {
  if (e instanceof ApiError) return e.status === 0 ? 'İnternet bağlantısı yok.' : e.message;
  return fallback;
}

/** Sorgu dizgisi (boş değerler atlanır). */
export function qs(params: Record<string, unknown>): Record<string, string | number | boolean> {
  const out: Record<string, string | number | boolean> = {};
  for (const [k, v] of Object.entries(params))
    if (v !== undefined && v !== null && v !== '') out[k] = v as string | number | boolean;
  return out;
}
